import type { CSSProperties } from "react";
import { DSFont } from "@/components/design-system/ArtistDesignSystem";
import type { GenArtModelMetricSpec } from "./genArtCatalog";

export interface GenArtMetricProps {
	readonly spec: GenArtModelMetricSpec;
	readonly align: "left" | "center" | "right";
}

const columnStyle = (align: GenArtMetricProps["align"]): CSSProperties => ({
	display: "flex",
	flexDirection: "column",
	gap: "4px",
	alignItems:
		align === "left" ? "flex-start" : align === "right" ? "flex-end" : "center",
	minWidth: 0,
});

/**
 * GenArtMetric — one column of the three-column model parameter row.
 * Mirrors iOS `metric(title:subtitle:)` (genArtHeavy 20px title,
 * genArtRegular 12px secondary subtitle).
 */
export function GenArtMetric({ spec, align }: Readonly<GenArtMetricProps>) {
	return (
		<div style={columnStyle(align)}>
			<span
				style={{
					font: DSFont.genArtHeavy(20),
					lineHeight: 1.1,
					color: "var(--ds-text-primary)",
				}}
			>
				{spec.title}
			</span>
			<span
				style={{
					font: DSFont.genArtRegular(12),
					color: "var(--ds-text-secondary)",
					lineHeight: 1.2,
				}}
			>
				{spec.subtitle}
			</span>
		</div>
	);
}
